module.exports = __webpack_public_path__ + "static/img/authority.71e292ad.jpg";